import { BaseEntity } from '@base-entities';
import { ActivityTransformer } from '../transformer';
import { IBaseTransformerRepository } from '@base-repositories';

export function makeActivityTransformer<E extends BaseEntity = BaseEntity>(): IBaseTransformerRepository<E> {
  return new ActivityTransformer<E>();
}
